export const philosophyTenets = [
  {
    title: 'Clarity',
    kicker: 'What remains when noise is removed.',
    body: 'Most choices are reactions. We take fewer of them, slowly, and let each one answer to the same quiet standard.',
  },
  {
    title: 'Health',
    kicker: 'The self as first capital.',
    body: 'A clear mind and a rested body come before any balance sheet. Every other form of wealth is held by them.',
  },
  {
    title: 'Duration',
    kicker: 'Time is the only true multiplier.',
    body: 'Patience is not waiting but trust in compounding. We act for those who will inherit the outcome, not for the quarter.',
  },
];
